let quickAddModulePromise;

function loadQuickAddIfPresent(root = document) {
  const hasQuickAdd =
    (root instanceof Element && root.matches('quick-add-component')) || root.querySelector?.('quick-add-component');

  if (!hasQuickAdd || quickAddModulePromise) return quickAddModulePromise;

  quickAddModulePromise = import('@theme/quick-add').catch((error) => {
    quickAddModulePromise = undefined;
    console.error('Failed to load the Quick Add module.', error);
  });

  return quickAddModulePromise;
}

loadQuickAddIfPresent();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) loadQuickAddIfPresent(event.target);
});
